import React from 'react';

import { useDispatch } from 'react-redux';

import Text from '@amzn/meridian/text';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { setTaskTableSettings } from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppSelector } from 'src/store/store';

import TaskModal from './taskModal/taskModal';
import TaskTable from './taskTable/taskTable';
import TopOptions from './topOptions/topOptions';

/**
 * Default component.
 */
const Tasks = () => {
  const dispatch = useDispatch();
  const { featureFlags } = useAppSelector((state) => state.user);
  const { isFetchTasksPending, taskTableSettings } = useAppSelector((state) => state.taskConfigPage);

  return (
    <div className="view-and-edit-tasks">
      {!featureFlags.TASK_GROUPING ? (
        <Text className="view-and-edit-tasks__content__text">
          Task configuration allows you to update the global dictionary to represent all possible physical actions an
          Amazon job might require and how the task is measured
        </Text>
      ) : null}
      <TopOptions />
      <LoadingSpinnerWrapper showSpinner={isFetchTasksPending}>
        <TaskTable />
      </LoadingSpinnerWrapper>
      <PaginationWithDropdown
        currentPage={taskTableSettings.currentPage}
        totalPages={taskTableSettings.totalPages}
        perPage={taskTableSettings.perPage}
        setPerPage={(perPage) => dispatch(setTaskTableSettings({ perPage }))}
        setCurrentPage={(currentPage) => dispatch(setTaskTableSettings({ currentPage }))}
      />
      <TaskModal />
    </div>
  );
};

// **** Export **** //

export default Tasks;
